module.exports = __webpack_public_path__ + "site/img/121.9e45616b.jpg";